import { useContainer } from "./useContainer"
import { useTranslation } from "react-i18next"

export const useLocale = () => {
  // subscribe to language changes
  useTranslation()

  return useContainer().accessibleLocale
}
